import useRouter from './useRouter';

var useRouteParams = function useRouteParams() {
  var _useRouter = useRouter(),
      match = _useRouter.match;

  return match.params;
};

export default useRouteParams;